<template lang='pug'>
td
  div.text--center.color--black60.show--bigScreens(v-if="type=='url'") 
    div(v-if="text") 有
    div(v-else) 無
  div.text--center.color--black60.show--bigScreens(v-else) {{text}}
</template>
<script>
export default {
  props: {
    text: String,
    type: String
  }
}
</script>
